import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../../../mui-theme';

export const styles = makeStyles(theme => ({
  inputContent: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    alignItems: 'center',
    flexDirection: 'column',
  },
  actionTitle: {
    fontSize: rem(2.285),
    lineHeight: rem(2.643),
    marginTop: '6.51vh',
    fontWeight: 500,
  },
  confirmMessage: {
    fontSize: rem(1.286),
    lineHeight: rem(1.428),
    marginBottom: '4vh',
    textAlign: 'center',
  },
  border: {
    borderBottom: `1.303vh solid ${theme.palette.secondary.main}`,
    width: '4.832vw',
    height: '1.303vh',
    margin: '3.906vh',
  },
  textInputField: {
    fontSize: rem(1.428),
    textAlign: 'center',
    maxWidth: '16.32vw',
    marginRight: '0.77vw',
  },
  textInput: {
    textAlign: 'center',
    fontSize: rem(1.428),
    letterSpacing: '0.02vw',
    color: theme.palette.info.main,
    '&:focus:not(.Mui-disabled),&:hover:not(.Mui-disabled)': {
      color: themeColor.modalTitle,
      fontWeight: 500,
    },
  },

  cancelContainer: {
    alignContent: 'start',
    width: '100%',
  },
  cancelButton: {
    marginRight: '1.9vw',
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
    fontSize: rem(1.143),
  },
  keypadArea: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  keypadContainer: {
    display: 'flex',
  },
}));
